import local from '@/utils/local'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import isoWeek from 'dayjs/plugin/isoWeek'
import dayOfYear from 'dayjs/plugin/dayOfYear'
dayjs.extend(isBetween)
dayjs.extend(isoWeek)
dayjs.extend(dayOfYear)

export default function () {
  let timer = local.get('open_hours')
  let holidays = local.get('holidays')
  const special_timer = local.get('specialHours') || []
  let arr = []
  let flag_special = special_timer?.find(
    item => dayjs(item.date).dayOfYear() == dayjs().dayOfYear()
  )

  if (flag_special) {
    arr = special_timer.filter(item => {
      item.end_time = dayjs().format('YYYY-MM-DD') + ' ' + item.end_time
      item.start_time = dayjs().format('YYYY-MM-DD') + ' ' + item.start_time
      return dayjs(item.date).dayOfYear() == dayjs().dayOfYear()
    })
  } else {
    arr = timer.filter(item => {
      item.end_time = dayjs().format('YYYY-MM-DD') + ' ' + item.end_time
      item.start_time = dayjs().format('YYYY-MM-DD') + ' ' + item.start_time
      return item.day_of_week == dayjs().isoWeekday()
    })
  }

  const timeList = arr.map(obj => {
    let isFind = holidays?.find(
      item =>
        dayjs(item.date).dayOfYear() == dayjs(obj.start_time).dayOfYear()
    )
    if (isFind) {
      return false
    } else {
      return getTodayHours(obj.start_time, obj.end_time)
    }
  })
  return timeList.some(item => item)
}

function getTodayHours(businessStart, businessEnd) {
  if (dayjs().isBetween(businessStart, businessEnd, 'minute', [])) {
    return true
  } else {
    return false
  }
}
